import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2895f20e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-animation tw-relative tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-flex tw-flex-col tw-rounded-[4px] tw-bg-[#FCFCFD] tw-border tw-border-solid tw-border-[#EFF0F1] sm:tw-min-w-[512px] max-sm:tw-max-w-[370px] sm:tw-h-[370px]" }
const _hoisted_2 = {
  id: "dash-cyber-health-score-title",
  class: "tw-flex tw-justify-between tw-items-center tw-h-[66px] tw-px-[20px] tw-py-[25px] tw-border-0 tw-border-b tw-border-solid tw-border-[#EFF0F1] tw-gap-2"
}
const _hoisted_3 = { class: "title tw-w-full tw-text-[#211F58] tw-text-[18px] tw-font-semibold tw-truncate" }
const _hoisted_4 = { class: "tw-flex tw-flex-col tw-flex-1" }
const _hoisted_5 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-full tw-min-h-[250px]"
}
const _hoisted_6 = { class: "tw-relative tw-flex tw-flex-1 tw-overflow-hidden tw-justify-center tw-min-h-[250px]" }
const _hoisted_7 = { class: "tw-flex tw-gap-5 tw-p-[20px] tw-pt-0 max-sm:tw-flex-col" }
const _hoisted_8 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot tw-bg-[#387DFF]" }, null, -1))
const _hoisted_10 = { class: "foot-text" }
const _hoisted_11 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot tw-bg-[#D9EDE2]" }, null, -1))
const _hoisted_13 = { class: "foot-text" }

import { computed, ref, watch } from "vue";
import IconCyberHealthScore from "@/components/svgs/iconCyberHealthScore.vue";
import CyberHealthScoreChart from "@/components/chart/cyberHealthScoreChart.vue";
import DummyCard from "@/components/dashboard/dummyCard.vue";

import store from "@/store";

import { getComponentUiText } from "@/utils/utilities";
import { TTypeMetric } from "@/interfaces/recommendations/IActionInterfaces";

type TypeGroupMetric = {
  checklistGroupScore: number;
  checklistGroupScoreMax: number;
}[];


export default /*#__PURE__*/_defineComponent({
  __name: 'cyberHealthScore',
  props: {
  metric: {
    type: Object as () => TTypeMetric,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["button:click"],
  setup(__props, { emit: emits }) {

const props = __props;



const dummyData = ref({
  checklistScore: 86,
  checklistScoreMax: 100,
});

const checklistId = computed(
  () => store.getters["Recommend/getLatestChecklistId"],
);

const isShowDummyCard = computed(
  () => !isLoading.value && (!metricData.value || !checklistId.value),
);


const metricData = ref<TTypeMetric>(props.metric);
const isLoading = ref(props.loading);

const checklistGroupMetrics = computed<TypeGroupMetric>(
  () => store.state.Recommend.checklistGroupMetrics,
);
const totalAddScore = computed(() =>
  checklistGroupMetrics.value.reduce((previousValue, currentValue) => {
    const addScore =
      (currentValue.checklistGroupScoreMax || 0) -
      (currentValue.checklistGroupScore || 0);
    return previousValue + addScore;
  }, 0),
);

watch(
  () => props.metric,
  (newVal) => {
    metricData.value = newVal;
  },
);

watch(
  () => props.loading,
  (newVal) => {
    isLoading.value = newVal;
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconCyberHealthScore),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
            "app-assess-recommendations-cyber-health-score-title-1",
          )), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(CyberHealthScoreChart, {
                "current-score": 
              !isShowDummyCard.value
                ? metricData.value?.checklistScore
                : dummyData.value.checklistScore
            ,
                "potential-score": totalAddScore.value,
                "total-score": 
              !isShowDummyCard.value
                ? metricData.value?.checklistScoreMax
                : dummyData.value.checklistScoreMax
            ,
                "pcnt-score": (metricData.value?.checklistScorePcnt || 0) * 100
              }, null, 8, ["current-score", "potential-score", "total-score", "pcnt-score"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getComponentUiText)(
                  "app-assess-recommendations-cyber-health-score-sub-title-1",
                )), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(getComponentUiText)(
                  "app-assess-recommendations-cyber-health-score-sub-title-2",
                )), 1)
              ])
            ])
          ], 64))
    ]),
    (isShowDummyCard.value && !isLoading.value)
      ? (_openBlock(), _createBlock(DummyCard, {
          key: 0,
          title: 
        _unref(getComponentUiText)('app-dashboard-dummy-title-cyber-health-score-1')
      ,
          "title-button": 
        _unref(getComponentUiText)('app-assessment-button-create-button-2')
      ,
          "title-class": 'tw-w-[276px]',
          "onButton:click": _cache[0] || (_cache[0] = () => emits('button:click'))
        }, null, 8, ["title", "title-button"]))
      : _createCommentVNode("", true)
  ]))
}
}

})